import Icon from '../components/Icon.vue'

Icon.register({
  church: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M464.5 246.7L352 179.2V128H400C408.8 128 416 120.8 416 112V80C416 71.2 408.8 64 400 64H352V16C352 7.2 344.8 0 336 0H304C295.2 0 288 7.2 288 16V64H240C231.2 64 224 71.2 224 80V112C224 120.8 231.2 128 240 128H288V179.2L175.5 246.7A32-32 0 0 1 160 274.1V512H256V416C256 380.6 284.6 352 320 352S384 380.6 384 416V512H480V274.1C480 262.9 474.1 252.5 464.5 246.7zM0 396V496C0 504.8 7.2 512 16 512H128V320L19.4 366.5A32-32 0 0 1 0 396zM620.6 366.5L512 320V512H624C632.8 512 640 504.8 640 496V396C640 383.2 632.4 371.6 620.6 366.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/church.js
// module id = GE5t
// module chunks = 144